import ListPurchase from "./component/ListPurchase"
import { useState } from "react"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import { ToolBarStyle } from "src/pages/ADMIN/HumanResource/Work/Task/styled"
import BtnExportExcel from "src/components/BtnExportExcel"
import ReportService from "src/services/ReportService"
const Index = props => {
  const [filter, setFilter] = useState({})
  const [refresh, setRefresh] = useState(false)
  const [excelKeyword, setExcelKeyword] = useState("")
  return (
    <>
      {" "}
      <div>
        <WrapperStyle>
          <ToolBarStyle>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
                marginBottom: 20,
                flexWrap: "wrap",
                gap: 8,
              }}
              className="px-2 p-md-0"
            >
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#005F90",
                  margin: 0,
                }}
              >
                {" "}
                BÁO CÁO PHẦN MUA
              </h3>
            </div>
            <div className="right-side d-none d-md-flex">
              <BtnExportExcel
                api={ReportService.exportExcelReportAgencyPurchase}
                filter={filter}
                fileName="Báo_cáo_phần_mua"
                buttonText="Xuất Excel"
                keyword={excelKeyword}
              />
            </div>
            <div style={{ width: "100%" }} className="px-2 p-md-0">
              <ListPurchase
                scroll={{ x: true }}
                setParentFilter={setFilter}
                filter={filter}
                refresh={refresh}
                setRefresh={setRefresh}
                setExcelKeyword={setExcelKeyword}
              />
            </div>
          </ToolBarStyle>
        </WrapperStyle>
      </div>
    </>
  )
}
export default Index
